import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skel-card" }
const _hoisted_2 = { class: "skel-card-main" }
const _hoisted_3 = { class: "skel-card-left" }
const _hoisted_4 = { class: "skel-card-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonBlock = _resolveComponent("SkeletonBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SkeletonBlock, {
          width: "70%",
          height: "16px"
        }),
        _createVNode(_component_SkeletonBlock, {
          width: "50%",
          height: "11px"
        }),
        _createVNode(_component_SkeletonBlock, {
          width: "40%",
          height: "11px"
        }),
        _createVNode(_component_SkeletonBlock, {
          width: "60%",
          height: "11px"
        }),
        _createVNode(_component_SkeletonBlock, {
          width: "90px",
          height: "90px",
          radius: "50%"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SkeletonBlock, {
          width: "100%",
          height: "100%",
          radius: "10px"
        })
      ])
    ])
  ]))
}